import { render, staticRenderFns } from "./age-panel.vue?vue&type=template&id=79fdc802&"
import script from "./age-panel.vue?vue&type=script&lang=js&"
export * from "./age-panel.vue?vue&type=script&lang=js&"
import style0 from "./age-panel.vue?vue&type=style&index=0&id=79fdc802&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports